<template>
    <ul
        class="l-ss-c-catalog-categories-list">
        <li @click="$emit('change', { event: $event, category })">
            <a
                :href="makeCategoryUrl(category.id)"
                class="l-ss-c-catalog-category-subtitle">{{ category.title }}</a>
        </li>

        <li v-if="category.child.length">
            <ul class="l-ss-c-catalog-sub-categories-list">
                <li
                    v-for="subCategory in thirdLevelCategories"
                    :key="subCategory.id"
                    @click="$emit('change', { event: $event, category: subCategory })">
                    <a
                        :href="makeCategoryUrl(subCategory.id)"
                        class="l-ss-c-catalog-sub-category-title"
                        v-html="subCategory.title">
                    </a>
                </li>
            </ul>
        </li>

        <li v-if="isVisibleShowMoreBtn">
            <show-more-btn v-model="isOpenFullCategoriesList"/>
        </li>
    </ul>
</template>

<script>
    import { computed, ref, inject } from '@/lib/vue-composition-api.js';

    import iconArrowRight from '@/core/assets/images/icons/arrow-right.svg';
    import ShowMoreBtn from '@/core/components/show-more-btn.vue';

    const MAX_THIRD_LEVEL_CATEGORIES = 5;

    export default {
        components: { ShowMoreBtn },
        props: {
            category: {
                type: Object,
                required: true,
            },
        },
        setup(props) {
            const isOpenFullCategoriesList = ref(false);

            const showMoreBtnText = computed(() => {
                return isOpenFullCategoriesList.value ? 'Скрыть' : 'Показать все';
            });

            const thirdLevelCategories = computed(() => {
                return isOpenFullCategoriesList.value ?
                    props.category.child :
                    props.category.child.slice(0, MAX_THIRD_LEVEL_CATEGORIES);
            });

            const isVisibleShowMoreBtn = props.category.child.length > MAX_THIRD_LEVEL_CATEGORIES;

            const makeCategoryUrl = inject('makeCategoryUrl');

            return {
                iconArrowRight,
                thirdLevelCategories,
                isOpenFullCategoriesList,
                isVisibleShowMoreBtn,
                makeCategoryUrl,
                showMoreBtnText,
            };
        },
    };
</script>>
